module.exports = __webpack_public_path__ + "media/images/enhanced-bgc-badge-f1dcfbe79084e1f77e39f0a2a6b1ed24.svg";